import React from "react";
import columns from "../../../../react-table/helpers/columns";
import HeaderChartButton from "../../../common/components/HeaderChartButton";
import charts from "./CarditResditBestPracticeElementsCharts";
import ReportDefinitions from "../../../../common/config/ReportDefinitions";
import UserTypes from "../../../../common/redux/actions/types/UserTypes";

export function get107BNavigationProps(rowInfo) {
  return rowInfo && rowInfo.row
    ? {
        reportId: ReportDefinitions.RESDIT_74_21_PERFORMANCE_CARRIER_107B.id,
        mainReportId:
          ReportDefinitions.RESDIT_74_21_PERFORMANCE_CARRIER_107B.id,
        requestParams: {
          originExchangeOffices: [rowInfo.row.operator],
        },
        selectionCriteriaOptions: {
          includeSelectionCriteria: true,
        },
      }
    : {};
}

export function get108NavigationProps(rowInfo) {
  return rowInfo && rowInfo.row
    ? {
        reportId: ReportDefinitions.CARDIT_NESTING_CARRIER.id,
        mainReportId: ReportDefinitions.CARDIT_NESTING_CARRIER.id,
        requestParams: {
          originExchangeOffices: [rowInfo.row.operator],
        },
        selectionCriteriaOptions: {
          includeSelectionCriteria: true,
        },
      }
    : {};
}

export function get107NavigationProps(rowInfo) {
  return rowInfo && rowInfo.row
    ? {
        reportId: ReportDefinitions.CARDIT_CRITICAL_ELEMENTS_CARRIER.id,
        mainReportId: ReportDefinitions.CARDIT_CRITICAL_ELEMENTS_CARRIER.id,
        requestParams: {
          originExchangeOffices: [rowInfo.row.operator],
        },
        selectionCriteriaOptions: {
          includeSelectionCriteria: true,
        },
      }
    : {};
}

export function get104NavigationProps(rowInfo) {
  return rowInfo && rowInfo.row
    ? {
        reportId: ReportDefinitions.CARDIT_TIMELINESS_ANALYSIS.id,
        mainReportId: ReportDefinitions.CARDIT_TIMELINESS_ANALYSIS.id,
        requestParams: {
          originExchangeOffices: [rowInfo.row.operator],
        },
        selectionCriteriaOptions: {
          includeSelectionCriteria: true,
        },
      }
    : {};
}

export const ownImpcProps = (userType) => (state, rowInfo) => {
  const className =
    userType !== UserTypes.IPC && rowInfo && rowInfo.original.ownOperator
      ? "bg-blue-spindle"
      : "";
  return { className };
};

export const isOwnOperator = (userType) => (rowInfo) =>
  userType === UserTypes.IPC ||
  (rowInfo && rowInfo.original && rowInfo.original.ownOperator === true);

function splitData(data) {
  return data.reduce(
    (acc, row) => {
      if (row.operator && row.operator.toLowerCase() === "total") {
        acc.totalRow = row;
      } else {
        acc.dataRows.push(row);
      }
      return acc;
    },
    {
      totalRow: undefined,
      dataRows: [],
    }
  );
}

export default (data, userType) => {
  const { dataRows } = splitData(data);
  const {
    TextColumn,
    NonZeroNumberColumn,
    PercentageColumn,
    PercentageZeroNavigationColumn,
    NumberColumn,
  } = columns(dataRows);

  return (setChartMeta) => [
    {
      Header: "",
      columns: [
        new TextColumn("Operator", "operator").withGetProps(
          ownImpcProps(userType)
        ),
        new NonZeroNumberColumn("receptacles", "receptacles").withShow(false),
      ],
    },
    {
      Header: () => (
        <HeaderChartButton
          title="RESDIT"
          action={setChartMeta}
          chartMeta={charts.resdit}
        />
      ),
      columns: [
        new PercentageZeroNavigationColumn(
          new PercentageColumn("74", "resdit.resdit74").withGetProps(
            ownImpcProps(userType)
          ),
          get107BNavigationProps,
          isOwnOperator(userType)
        ),
        new PercentageZeroNavigationColumn(
          new PercentageColumn("21", "resdit.resdit21").withGetProps(
            ownImpcProps(userType)
          ),
          get107BNavigationProps,
          isOwnOperator(userType)
        ),
        new PercentageColumn("23", "resdit.resdit23").withGetProps(
          ownImpcProps(userType)
        ),
        new NumberColumn("", "resdit.nbrResdit74").withShow(false),
        new NumberColumn("", "resdit.nbrResdit21").withShow(false),
        new NumberColumn("", "resdit.nbrResdit23").withShow(false),
        new NumberColumn("", "resditMeasurable").withShow(false),
      ],
    },
    {
      Header: () => (
        <HeaderChartButton
          title="Nesting"
          action={setChartMeta}
          chartMeta={charts.nesting}
        />
      ),
      columns: [
        new PercentageZeroNavigationColumn(
          new PercentageColumn("CJID", "nesting.cjid").withGetProps(
            ownImpcProps(userType)
          ),
          get108NavigationProps,
          isOwnOperator(userType)
        ),
        new PercentageZeroNavigationColumn(
          new PercentageColumn("ULD ID", "nesting.uldid").withGetProps(
            ownImpcProps(userType)
          ),
          get108NavigationProps,
          isOwnOperator(userType)
        ),
        new NumberColumn("", "nesting.nbrCjid").withShow(false),
        new NumberColumn("", "nesting.nbrUldId").withShow(false),
        new NumberColumn("", "criticalMeasurable").withShow(false),
      ],
    },
    {
      Header: () => (
        <HeaderChartButton
          title="Critical elements"
          action={setChartMeta}
          chartMeta={charts.criticalElements}
        />
      ),
      columns: [
        new PercentageZeroNavigationColumn(
          new PercentageColumn(
            "LHOT origin",
            "criticalElements.lhotOrigin"
          ).withGetProps(ownImpcProps(userType)),
          get107NavigationProps,
          isOwnOperator(userType)
        ),
        new PercentageZeroNavigationColumn(
          new PercentageColumn(
            "LHOT destination",
            "criticalElements.lhotDestination"
          ).withGetProps(ownImpcProps(userType)),
          get107NavigationProps,
          isOwnOperator(userType)
        ),
        new PercentageZeroNavigationColumn(
          new PercentageColumn(
            "Contract reference",
            "criticalElements.contractReference"
          ).withGetProps(ownImpcProps(userType)),
          get107NavigationProps,
          isOwnOperator(userType)
        ),
        new PercentageZeroNavigationColumn(
          new PercentageColumn(
            "Booking reference (PAWB)",
            "criticalElements.bookingReference"
          ).withGetProps(ownImpcProps(userType)),
          get107NavigationProps,
          isOwnOperator(userType)
        ),
        new NumberColumn("", "criticalElements.nbrLhotOrigin").withShow(false),
        new NumberColumn("", "criticalElements.nbrLhotDestination").withShow(
          false
        ),
        new NumberColumn("", "criticalElements.nbrContractReference").withShow(
          false
        ),
        new NumberColumn("", "criticalElements.nbrBookingReference").withShow(
          false
        ),
      ],
    },
    {
      Header: () => (
        <HeaderChartButton
          title="CARDIT"
          action={setChartMeta}
          chartMeta={charts.carditTimeliness}
        />
      ),
      columns: [
        new PercentageZeroNavigationColumn(
          new PercentageColumn("On time", "cardit.onTime").withGetProps(
            ownImpcProps(userType)
          ),
          get104NavigationProps,
          isOwnOperator(userType)
        ),
        new NumberColumn("", "cardit.nbrOnTime").withShow(false),
        new NumberColumn("", "timelinessMeasurable").withShow(false),
      ],
    },
  ];
};
